import { memo, useMemo } from "react";
import BrokenImageIcon from '@mui/icons-material/BrokenImage';

import "./BrokenImage.scss";

export default memo(function BrokenImage({ className, widthPx = 100, heightPx = 100, style, ...props }) {

    const displayProps = useMemo(() => {
        return {
            style: {
                aspectRatio: `${widthPx / heightPx}`,
                ...style,
            },
        };
    }, [heightPx, widthPx, style]);

    console.log("displayProps", displayProps);

    return (
        <span className={`BrokenImage ${className ?? ''}`} {...props}>
            <span className={`BrokenImage__inner`} {...displayProps}>
                <span className="BrokenImage__placeholder">
                    <BrokenImageIcon />
                </span>
            </span>
        </span>
    )
});